module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/en/p10-adb51fe7abe786c341a394b624b2413f.png";